// PASTE #276: Google Analytics 4 wiring. The measurement ID lives in
// NEXT_PUBLIC_GA_MEASUREMENT_ID and is only set in the Vercel PRODUCTION
// env, so preview/dev builds never load GA (test traffic stays out of the
// data). NODE_ENV === "production" is an extra guard for local `next start`.

export const GA_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? "";

// True only in a production build that actually has a measurement ID.
export const GA_ENABLED =
  GA_MEASUREMENT_ID !== "" && process.env.NODE_ENV === "production";

// Anonymized event params only - NEVER pass email/name/address or any
// identity-tied value (locked: no PII to GA). value/currency are fine.
type GaEventParams = Record<string, string | number | boolean | undefined>;

// Fire a GA4 event. No-op when gtag isn't on the page (dev/preview, or
// before the script loads), so callers can fire unconditionally.
export function trackEvent(name: string, params?: GaEventParams): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as {
    gtag?: (command: string, event: string, params?: GaEventParams) => void;
  };
  if (typeof w.gtag !== "function") return;
  w.gtag("event", name, params ?? {});
}
